import { render } from "./ProductionPriority.vue?vue&type=template&id=28966adc&scoped=true"
import script from "./ProductionPriority.vue?vue&type=script&lang=js"
export * from "./ProductionPriority.vue?vue&type=script&lang=js"

import "./ProductionPriority.vue?vue&type=style&index=0&id=28966adc&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28966adc"]])

export default __exports__